module.exports = __webpack_public_path__ + "img/shopping-bag-solid.6c10a1d9.svg";